<template>
	<value-container v-if="view_only" :value="text" :label="label" :md="md"/>
	<component v-else :is='c_tag' :md2="md==2" :md3="md==3" :md4="md==4" :md5="md==5" :md8="md==8">
		<fs1-span><b>{{label || ''}}</b></fs1-span>
		<slot></slot>
		<v-text-field
			@wheel="$event.target.blur()"
			:class="text != null ? '': (optional?'':'textEmpty')"
			:placeholder="placeholder_num"
			:value="text"
			:disabled="disabled"
			:step="step"
			:min="min===undefined?0:min"
			:max="max===undefined?null:max"
			type="number"
			:prepend-icon="p_icon"
			v-on:input="updateInput"/>
			<value-container v-if="old_value != undefined" :value="old_value" class_name="output_old_value_edit"/>
	</component>
</template>

<script>
import inputs from '../mixins/inputs/inputs.js';
export default {
	mixins:[inputs],
	model: { prop: "text", event: "input" },
	props: ['text','min','max','float','step'],
	computed:{
		placeholder_num() { return this.label ? ` Ingrese ${this.label} ${this.placeholder_min_max}` : (this.placeholder || this.placeholder_min_max) },
		placeholder_min () { return this.min ? `min:${this.min}`:'' },
		placeholder_max () { return this.max ? `max:${this.max}`:'' },
		placeholder_min_max() { return [this.placeholder_min,this.placeholder_max].join(' - ')},
	},
  methods: { updateInput(v) {this.$emit('input', this.float ? parseFloat(v): parseInt(v)) } },
	watch:{
		text(){
			if (isNaN(this.text)){
				if (this.min) this.updateInput(this.min);
			} else {
				if (this.min && this.text < this.min) this.updateInput(this.min);
				if (this.max && this.text > this.max) this.updateInput(this.max);
			}
		}
	}
};
</script>
